import React from 'react';

import { OnboardProvider } from './context';
import OnboardComponent from './OnboardComponent';

const Onboard = () => {
  return (
    <OnboardProvider>
      <OnboardComponent />
    </OnboardProvider>
  );
};

export default Onboard;
